import React from "react";

export default function AdjectifsEditor({ adjectifs, onChange }) {
  const update = (i, key, val) => {
    const next = adjectifs.map((g, idx) => (idx === i ? { ...g, [key]: val } : g));
    onChange(next);
  };
  const add = () => onChange([...adjectifs, { label: "", words: "" }]);
  const remove = (i) => onChange(adjectifs.filter((_, idx) => idx !== i));

  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Adjectifs ({adjectifs.length} groupes)</strong></legend>
      {adjectifs.map((g, i) => (
        <div key={i} style={{ marginBottom: 12, display: "flex", gap: 8 }}>
          <input
            placeholder="Label (ex: Noyau identitaire)"
            value={g.label}
            onChange={(e) => update(i, "label", e.target.value)}
            style={{ flex: 1, padding: 8 }}
          />
          {/* Zone de texte et non champ simple : un retour à la ligne saisi ici
              est conservé à la publication (cf. .adjectifs__words). */}
          <textarea
            placeholder="Adjectifs séparés par virgules — Entrée pour couper la ligne"
            value={g.words}
            onChange={(e) => update(i, "words", e.target.value)}
            rows={2}
            style={{ flex: 2, padding: 8, fontFamily: "inherit", resize: "vertical" }}
          />
          <button onClick={() => remove(i)}>×</button>
        </div>
      ))}
      <button onClick={add}>+ Ajouter un groupe</button>
    </fieldset>
  );
}
